module.exports = __webpack_public_path__ + "static/media/Oaktree---career---medium.55115a91.svg";